import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PasswordStrengthValidator {
  static isUndefinedOrEmpty(control: AbstractControl): any | undefined {
    if (!control || !control.value || control.value.length === 0) {
      return undefined;
    }
  }

  // validate(criteria: string, regex: RegExp): ValidatorFn {
  //   const validator = (control: AbstractControl): { [key: string]: any } | null => {
  //     this.isUndefinedOrEmpty(control);
  //     if (!regex.test(control.value)) {
  //       const failed: { [key: string]: { actualValue: string; requiredPattern: RegExp } } = {};
  //       failed[criteria] = {
  //         actualValue: control.value,
  //         requiredPattern: regex,
  //       };
  //       return failed;
  //     }
  //     return null;
  //   };
  //   return validator;
  // }

  static validate(criteria: string, regex: RegExp): ValidatorFn {
    const validator = (control: AbstractControl): { [key: string]: any } | null => {
      this.isUndefinedOrEmpty(control);
      if (!regex.test(control.value)) {
        const failed: any = {};
        failed[criteria] = {
          actualValue: control.value,
          requiredPattern: regex,
        };
        return failed;
      }
      return null;
    };
    return validator;
  }

  static confirm(password: string): ValidatorFn {
    const validator = (control: AbstractControl): { [key: string]: any } | null => {
      this.isUndefinedOrEmpty(control);
      if (control.value !== password) {
        return {
          notConfirmed: {
            password: password,
            passwordConfirmation: control.value,
          },
        };
      }
      return null;
    };
    return validator;
  }

  static passwordsMatch(controlName: string, matchingControlName: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const passwordControl = group.get(controlName);
      const confirmPasswordControl = group.get(matchingControlName);

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        const error = {
          notConfirmed: {
            password: passwordControl.value,
            passwordConfirmation: confirmPasswordControl.value,
          },
        };
        confirmPasswordControl.setErrors(error);
        return error;
      } else {
        confirmPasswordControl.setErrors(null);
        return null;
      }
    };
  }
}
